$(function () {
  if ($('.landing-slider-section').length > 0) {

    var bWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || window.width();
    var slidersettings = {};
    if (bWidth >= 900) {
      slidersettings = {
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false
      };
    } else if (bWidth <= 575) {
      slidersettings = {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false
      };
    } else {
      
      slidersettings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false
      };
    }

    //Init slick slider
    var bodice_slider = $('.bodice-landing-slider').slick(slidersettings);

    var skirt_slider = $('.skirt-landing-slider').slick(slidersettings);

    //Extend slider slideTo event on click
    $('.left-control').on('click', function () {
      bodice_slider.slick('slickPrev');
    });

    $('.skirt-left').on('click', function () {
      skirt_slider.slick('slickPrev');
    });

    $('.right-control').on('click', function () {
      bodice_slider.slick('slickNext');
    });

    $('.skirt-right').on('click', function () {
      skirt_slider.slick('slickNext');
    });

    setTimeout(function () {
      $('.landing-slider-section .slider-wrapper').css({ visibility: 'visible', opacity: 1 });
    }, 800);
  }
});